export default __webpack_public_path__ + "media/images/svg/large-arrow-icon-6a508de1156cd8493eccefd4d47884cd.svg";